import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { SentAttribution } from '@/shared/lib/attribution';

export interface EventsState {
  catalogOpened?: SentAttribution;
  cartItemAdded?: SentAttribution;
  cartOpened?: SentAttribution;
  pendingCatalogReopen: boolean;
}

const initialState: EventsState = {
  pendingCatalogReopen: false,
};

export const eventsSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {
    markCatalogOpenedSent(state, { payload }: PayloadAction<SentAttribution>) {
      state.catalogOpened = payload;
      state.pendingCatalogReopen = false;
    },
    markCartItemAddedSent(state, { payload }: PayloadAction<SentAttribution>) {
      state.cartItemAdded = payload;
    },
    markCartOpenedSent(state, { payload }: PayloadAction<SentAttribution>) {
      state.cartOpened = payload;
    },
    markOrderPlaced(state) {
      // after creating an order, we delete the channels so that the next funnel is not multi-channel
      if (state.catalogOpened) state.catalogOpened = { at: state.catalogOpened.at };
      state.cartOpened = undefined;
      state.cartItemAdded = undefined;
      state.pendingCatalogReopen = true;
    },
    resetEvents(state) {
      state.catalogOpened = undefined;
      state.cartItemAdded = undefined;
      state.cartOpened = undefined;
      state.pendingCatalogReopen = false;
    },
  },
});

export const { markCatalogOpenedSent, markCartItemAddedSent, markCartOpenedSent, markOrderPlaced, resetEvents } =
  eventsSlice.actions;

export const eventsReducer = eventsSlice.reducer;

export const selectEventsState = (state: { events: EventsState }) => state.events;
export const selectPendingCatalogReopen = (state: { events: EventsState }) => state.events.pendingCatalogReopen;
